import type { Company, MyCompanyResponse } from '@/types';
import { createContext } from 'react';

export interface CompanyContextType {
  userCompanies: MyCompanyResponse[];
  activeCompany: Company | null;
  isLoading: boolean;
  setActiveCompany: (company: Company) => Promise<void>;
  refreshCompanies: () => Promise<void>;
  clearActiveCompany: () => void;
}

export const CompanyContext = createContext<CompanyContextType | undefined>(undefined);
